import React, { Component } from 'react';
import type Node from 'react';
import isEmail from 'validator/lib/isEmail';
import { Modal, ModalBody, Form, Input, Button } from 'reactstrap';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';

type Props = {
  on: boolean,
  toggle: Function,
  aboveEmail: Node,
  belowEmail: Node,
  cookieName: string | null,
  onSuccess: () => void,
  context: string,
};

export default class EmailSubscriptionMessageModal extends Component<Props> {
  static defaultProps = {
    onSuccess: () => {},
    context: '',
  };

  state = {
    email: '',
    emailErrorMessage: null,
  };

  handleSubmit = e => {
    e.preventDefault();
    const error = this.validateEmail();

    console.log(error);
    console.log('comes inside handle submit function');

    return error ? this.handleEmailErrorMessage(error) : this.postData();
  };

  validateEmail = () => {
    const { email } = this.state;

    if (!email) return 'Oops, you forgot your email';
    if (!isEmail(email)) return 'Is that a valid email.?';
  };

  postData = async () => {
    const { email } = this.state;
    const { toggle, onSuccess, context } = this.props;
    const { newslettersSubscriptions } = endpoints.profile;

    try {
      await api.postWithoutToken(newslettersSubscriptions, {
        email,
        context,
      });
      toggle();
      onSuccess();
    } catch (e) {
      this.handleEmailErrorMessage(
        'Oops, there seems to be a problem. Please try again later.'
      );
    }
  };

  handleEmailErrorMessage = error => this.setState({ emailErrorMessage: error });

  handleEmailChange = e => this.setState({ email: e.target.value });

  render() {
    const { on, toggle, aboveEmail, belowEmail } = this.props;
    const { email, emailErrorMessage } = this.state;

    return (
      <Modal isOpen={on} toggle={toggle} className="full-width-modal">
        <ModalBody>
          <div className="modal-box">
            {aboveEmail}
            <div className="email-box">
              <Form id="betaMessageForm" inline>
                <Input
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  placeholder="something@domain.com"
                  className="input-error"
                  autofocus
                  onChange={this.handleEmailChange}
                />
                <Button
                  color="let-know"
                  onClick={this.handleSubmit}
                  id="betaMessageLemmeKnow"
                >
                  Get It!
                </Button>
                <div className="error">{emailErrorMessage && emailErrorMessage}</div>
              </Form>
            </div>
            {belowEmail}
            <Button color="invisible" onClick={toggle}>
              No Thanks
            </Button>{' '}
          </div>
        </ModalBody>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EmailSubscriptionMessageModal/EmailSubscriptionMessageModal.js